







































































































































import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import{
GetVoipQICaseReq,
GetVoipQICaseListReq,
SaveVoipQICaseReq,
AudioMarkText,
VoipQICaseData
} from "@/pbjs/xcommon/collection_pb.js";
import {
  GetVoipQITicketListReq, 
  GetTicketListReq,
  BatchAssignTicketReq,
  BatchRecycleTicketReq,
  BatchEntrustTicketReq,
  RollApplyTicketReq,
  ReduceTicketReq,
  GetTicketListParamReq,
  CloseTicketReq,
  Bool,
} from "@/pbjs/external/ticket/ticket_pb";

import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
import {Component, Prop, Provide, Vue,Watch} from "vue-property-decorator";
@Component({
    name: "ManualUpgradeTicketDialogue",
    components: {
        MaskComponent: () => import("@/components/Maskbig.vue")
    }
})
export default class ApplicationReview extends Vue {
    @Prop() recotData!: any;
    @Prop() sopeRow!:any;
    @Provide() private audioPlayLoading:  Boolean = false;
    @Provide() private timelong: number = 0;
    @Provide() private audio: any = [];
    @Provide() private resultData: any = []; // 列表结果
    @Provide() private ManualUpgradeTicketDialogueForm: any = {
        OverdueDay: ""
    };
    @Provide() private rules: any = {
        OverdueDay: [{ required: true, message: 'Pls enter a number value', trigger: 'blur' }]
    };
    // lee 手动升级操作的接口请求是否完成，布尔值
    @Provide() private inputValue: any = [];
    @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
    @Provide() private Aging: any = '';
    @Provide() private selectTextId: any = '';
    @Provide() private sliderValue: any = [
     100,20,48
   ];
    @Provide() private calltextList: any = [
    {}
  ];
  @Provide() private caseresult: any = '';
  @Provide() private audiorecordurl: any = '';
  @Provide() private calldirection: any = '';
  @Provide() private hangupcause: any = '';
  @Provide() private starttimestamp: any = '';
  @Provide() private dialinfo: any = {};
  @Provide() private recotdingForm: any = {
    name: null,
    result:[{label:''},{label:''},{label:''},{label:''},],
    resultTxt:''
  }
   @Provide() private RecotdinCheckList: any = [
    {label:"dashbordDy.normal"},
    {label:"dashbordDy.AbusiveCustomer"},
    {label:"dashbordDy.sop"},
    {label:"dashbordDy.CustomerPromises"},
  ];
  @Provide() private  dynamicTags: any = [
   [],[],[],[]
 ];
 @Provide() private inputVisible: any = [
    {Label:0,bool:false,list:[]},
    {Label:1,bool:false,list:[]},
    {Label:2,bool:false,list:[]},
    {Label:3,bool:false,list:[]},
  ];
    @Watch('recotData')
    onrecotDataChange(val: number | null){
        if (this.recotData.commonout.code==0) {
          this.getVoipQICaseFuc(this.recotData)
        }
        // if (this.recotData.media.commonout.code==0) {
        //     this.getVoipQICaseFuc(this.recotData)
        // }
    }
    //鼠标移动事件
   private getContenttext(){
     const selectTextId: any = (document as any).getSelection().anchorNode.parentNode.id;
     this.selectTextId=selectTextId
     return selectTextId
    //  const selectText: any = (document as any).getSelection();  
    //  const selectTextString: any = selectText.anchorNode.data;
    //  if (selectText.anchorOffset<selectText.focusOffset) {
    //    const selectTextvalue:any= selectTextString.substr(selectText.anchorOffset, selectText.focusOffset)  
    //    return selectTextvalue
    //  }else{
    //    const selectTextvalue:any= selectTextString.substr(selectText.focusOffset,selectText.anchorOffset)  
    //    return selectTextvalue
    //  }
   }
  private   showInput(index:number) {
        console.dir((document as any).getSelection())
        this.inputVisible[index].bool = true;
        this.$nextTick(()=> {
          // this.$refs.saveTagInput.$refs.input.focus();
        });
      }
  private   handleInputConfirm(index:number) {
    
        let inputValue = this.inputValue[index];
         if (inputValue.length>0) {
           this.dynamicTags[index].push(inputValue);
           this.inputVisible[index].list.push({
           ID:this.selectTextId,//(document as any).getSelection().anchorNode.parentNode.id,
           ContentMark:inputValue//this.getContenttext()//(document as any).getSelection().anchorNode.data
          })
         }
         this.inputVisible[index].bool = false;
         this.inputValue[index] = '';
      }
 private handleClose(tag:any,index:number) {
   this.dynamicTags[index].splice(this.dynamicTags[index].indexOf(tag), 1);  
 }
       //获取质检工单详情
//   private getVoipQICaseReq(row:any){
//     let request: any=new GetVoipQICaseReq()
//     request.setCommonin(setCommon());
//     request.setTicketid(Number(row.id));
//     request.setItemid(Number(row.itemid));
//     collectionServiceClient.getVoipQualityInspectionCase (
//       request,
//       {},
//       (err: any, response: any) => {
//         if (response) {
//           // if (response) {
            
//           // }
//           let data: any = response.toObject();
//         // this.$message.success("success")
//         let _fuc = this.getVoipQICaseFuc;
//         handleResponse(data, _fuc);
//         }
//         if (err) {
//         if (err.code == 16) {
//           this.$router.push("./login");
//         } else {
//           this.$message.error(err.errmsg || err.message);
//         }
//       }
//       }
//     )
//     // request.setCaseId(Number(row.orderid));     
//     // this.showDialogType=9
//     // this.rowMessage=row
//   }
 private getVoipQICaseFuc(data:any){
  this.calltextList=data.calltextList
  this.calldirection=data.dialinfo.calldirection
  this.dialinfo=data.dialinfo
  this.hangupcause=data.dialinfo.hangupcause
  this.starttimestamp=data.dialinfo.starttimestamp
  this.caseresult=data.caseresult
  // this.audiorecordurl=data.dialinfo.audiorecordurl
  //this.audiorecordurl="data:" + data.media.mediaheader + ";base64," + data.media.mediabody;
  // this.audiorecordurl=data.dialinfo.audiorecordname
  this.Aging=data.dialinfo.itemid
 }
  private submitRecotding(){
      this.SaveVoipQICaseReqRequest(4)
   }
   private LaterconfirmRecotding(){
      this.SaveVoipQICaseReqRequest(6)
   }
   private SaveVoipQICaseReqRequest(num:number){
      let request: any=new SaveVoipQICaseReq()
      let objData: any = new VoipQICaseData();
      let arr: any = [];
      this.inputVisible.forEach((item:any,index:any)=>{
        if (item.list.length>0) {
          item.list.forEach((n:any,m:any)=>{
            let audioMarkText: any = new AudioMarkText()
            audioMarkText.setContentmodify()  
            audioMarkText.setLabel(Number(item.Label)+1)
            audioMarkText.setId(n.ID)
            audioMarkText.setAudioid(Number(this.sopeRow.callrecordid))
            audioMarkText.setContentmark(n.ContentMark)
            arr.push(audioMarkText)
          })
        }
      })
      objData.setMarktextList(arr)
      objData.setItemid(105)
      objData.setTicketid(this.caseresult.ticketid)
      objData.setCalltype(this.recotdingForm.name)
      objData.setResult('0')
      objData.setComment(this.recotdingForm.resultTxt)
      objData.setStatus(num)
      objData.setCaselevel(this.caseresult.caselevel)
      // objData.addMarktext(audioMarkTextList)
      request.setCommonin(setCommon());
      request.setData(objData);
      collectionServiceClient.saveVoipQualityInspectionCase (
      request,
      {},
      (err: any, response: any) => {
         if (response) {
          let data: any = response.toObject();
        if (data.commonout.code==0) {
            this.$message.success('success')
            this.hideMaskVue()
        }else{
            this.$message.error(data.commonout.errmsg || data.commonout.message);
            // this.hideMaskVue()
        }
        }
        if (err) {
        if (err.code == 16) {
          this.$router.push("./login");
        } else {
          this.$message.error(err.errmsg || err.message);
        }
        }
      })
   }
    // lee 获取录音文件
  private async audioPlay (val: any,index:number,timelong:number) {
    // row.videoLoading = true;
    this.audioPlayLoading=true
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: this.sopeRow.callrecordid 
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      // row.videoLoading = false;
      // row.videoShow = true;
      this.audioPlayLoading=false
      this.audiorecordurl =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
      this.timelong=timelong
      this.audio=this.$refs.audioExl
      this.audio.currentTime=val
      this.audio.play()
      this.sliderValue[index]=100
      
    }
  }
  //  private  getFileInfoV2() {
  //         if (!this.audiorecordurl) {
  //           this.getFileInfoV2()
  //         }
           
  //   // this.timeupdateFunc(index) (this.audio.currentTime)/this.timelong*100;
  // }
   private hideMaskVue() {
        this.$emit("hideManualUpgradeTicketDialogue1", false
        // {
        //     hidden: true,
        //     val: null
        // }
        );
    }
}
